export const CREDIT_PACK_REQUEST = "CREDIT_PACK_REQUEST";
export const CREDIT_PACK_SUCCESS = "CREDIT_PACK_SUCCESS";
export const CREDIT_PACK_FAILURE = "CREDIT_PACK_FAILURE";
